import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
const DappApi = () => {

  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const { i18n } = useTranslation()

  return (
    <div style={{
      padding: '20px',
      textAlign: 'center',
      display: location.pathname === '/dapp-api' ? 'block' : 'none'
    }}>
      <Spin spinning={loading}>
        <iframe
          src={`/docs/api.html?lang=${i18n.language}`}
          style={{
            margin: '0 auto',
            maxWidth: '1200px',
            width: '100%',
            height: 'calc(100vh - 117px - 64px - 40px)',
            border: 'none'
          }}
          onLoad={() => {
            setLoading(false)
          }}
          onError={() => setLoading(false)} />
      </Spin>
    </div>
  )
}

export default DappApi;